<template>
  <b-badge
    pill
    variant="light"
    class="remove-minute-event-icon text-danger"
    @click="remove(event, true)"
  >
    <font-awesome-icon icon="times" size="1x" />
  </b-badge>
</template>

<script>
import minutesMixin from "@/mixins/minutes";

export default {
  mixins: [minutesMixin],
  props: {
    event: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
    allowRemoveLeftEvent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    remove(event, saveInDb) {
      if (this.allowRemoveLeftEvent) {
        this.$emit("removeEvent", { event: event, saveInDb: saveInDb });
      } else {
        this.removeMinuteEvent(event, saveInDb);
      }
    },
  },
};
</script>
